export default __webpack_public_path__ + "static/20_18-cff7c8cf574c46c28eec51df396f4202.png";